import CryptoJS from 'crypto-js'

const CryptoSecret = '_CRYPTO_JS_SECRET_'

/**
 * 加密数据
 * @param data - 数据
 * @param secret - 密钥
 */
export function Encrypt(data: string) {
    const newData = JSON.stringify(data)
    return CryptoJS.AES.encrypt(newData, CryptoSecret).toString()
}

/**
 * 解密数据
 * @param cipherText - 密文
 * @param secret - 密钥
 */
export function Decrypt(cipherText: string) {
    const bytes = CryptoJS.AES.decrypt(cipherText, CryptoSecret)
    const originalText = bytes.toString(CryptoJS.enc.Utf8)
    if (originalText) {
        return JSON.parse(originalText)
    }
    return null
}
